import type { DepartmentLocation } from "../../../../utils/models";
import type { CoverageRow } from "../types";

/**
 * Maps a Coverage row back to its `DepartmentLocation` so the editor can open. A row IS one config
 * record, so it carries that record's `locationId` — a direct id lookup. Returns `null` for
 * outside-config rows (no record) or when the id no longer resolves (stale config).
 */
export const resolveLocationForCoverageRow = (row: CoverageRow, locations: DepartmentLocation[]): DepartmentLocation | null => {
	if (row.outsideConfig || !row.locationId) return null;
	return locations.find((loc) => loc.id === row.locationId) ?? null;
};
